

// import React, { useState, useEffect } from "react";
// import { Box, Radio, RadioGroup, FormControlLabel } from "@mui/material";

// const CustomRadioButton = ({ name, value, onChange }) => {
//   const [status, setStatus] = useState(value || "active");

//   useEffect(() => {
//     setStatus(value);
//   }, [value]);

//   const handleChange = (event) => {
//     const newValue = event.target.value;
//     setStatus(newValue);
//     if (onChange) {
//       onChange(newValue);
//     }
//   };

//   return (
//     <div>
//       <label style={{
//         fontSize: "16px", display: "block",
//         // marginBottom: "10px"
//       }}>
//         Status
//       </label>
//       <Box>
//         <RadioGroup name={name} value={status} onChange={handleChange} row>
//           <FormControlLabel
//             value="male"
//             name={name}
//             control={
//               <Radio
//                 sx={{
//                   color: "#3B4056",
//                   "&.Mui-checked": { color: "#C38F51" },
//                 }}
//               />
//             }
//             label="Male"
//           />
//           <FormControlLabel
//             value="Female"
//             name={name}
//             control={
//               <Radio
//                 sx={{
//                   color: "#3B4056",
//                   "&.Mui-checked": { color: "#C38F51" },
//                 }}
//               />
//             }
//             label="Female"
//           />

//         </RadioGroup>
//       </Box>
//     </div>
//   );
// };

// export default CustomRadioButton;

import React, { useState, useEffect } from "react";
import { Box, Radio, RadioGroup, FormControlLabel } from "@mui/material";

const CustomRadioButton = ({ name, value,label, onChange, options = [] }) => {

    const [status, setStatus] = useState(value || options[0]?.value || "");

    useEffect(() => {
        setStatus(value);
    }, [value]);

    const handleChange = (event) => {
        const newValue = event.target.value;
        setStatus(newValue);
        if (onChange) {
            onChange(newValue);
        }
    };

    return (
        <div>
            <label
                style={{
                    fontSize: "16px",
                    display: "block",
                }}
            >
                {label || "Status"}
            </label>
            <Box>
                <RadioGroup name={name} value={status} onChange={handleChange} row>
                    {options.map((option) => (
                        <FormControlLabel
                            key={option.value}
                            value={option.value}
                            name={name}
                            control={
                                <Radio
                                    // sx={{
                                    //     color: "#3B4056",
                                    //     "&.Mui-checked": { color: "#C38F51" },
                                    // }}
                                />
                            }
                            label={option.label}
                        />
                    ))}
                </RadioGroup>
            </Box>
        </div>
    );
}

export default CustomRadioButton;
